import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/$locale/order/")({
  component: RouteComponent,
});

function RouteComponent() {
  return <div>Hello "/$locale/order/"!</div>;
}
